var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecisionBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.23,
    height: 19.494,
    viewBox: "0 0 21.23 19.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "browser_1_",
    "data-name": "browser (1)",
    d: "M16.49,1H4.34A4.345,4.345,0,0,0,0,5.34V15.754a4.345,4.345,0,0,0,4.34,4.34H16.49a4.345,4.345,0,0,0,4.34-4.34V5.34A4.345,4.345,0,0,0,16.49,1ZM4.34,2.736H16.49a2.6,2.6,0,0,1,2.6,2.6v.868H1.736V5.34A2.6,2.6,0,0,1,4.34,2.736ZM16.49,18.358H4.34a2.6,2.6,0,0,1-2.6-2.6V7.943H19.094v7.811A2.6,2.6,0,0,1,16.49,18.358Zm0-6.943a.868.868,0,0,1-.868.868H5.207a.868.868,0,0,1,0-1.736H15.622A.868.868,0,0,1,16.49,11.415Zm-3.472,3.472a.868.868,0,0,1-.868.868H5.207a.868.868,0,0,1,0-1.736h6.943A.868.868,0,0,1,13.019,14.886Z",
    transform: "translate(0.2 -0.8)",
    stroke: "#fff",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionBox);
export default __webpack_public_path__ + "static/media/decisionBox.d4f4e64adbb385f7dbcefc2d6e84b190.svg";
export { ForwardRef as ReactComponent };